import React, { useState, useImperativeHandle, useEffect, forwardRef } from 'react';
import Api from '../../../../../../_helpers/Api';

//images
import docIcon from '../../../../../../assets/img/icons/document.png';
import closeIcon from '../../../../../../assets/img/icons/close.png';
import loader from '../../../../../../assets/img/loader.svg';
import { trans } from '../../../../../../_providers/Translation';

function Van(props, ref) {

    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        id: null,
        data: null,
        employees: [],
        loading: false,
        update: false,
        onSave: null
    });

    const [validations, setValidations] = useState(null);

    useImperativeHandle(ref, () => ({
        open: () => {
            handleShow();
        },
        edit: id => {
            handleShow(id);
        },
        hide: () => {
            handleHide();
        },
        onSave: fn => {
            setPopup(prev => ({
                ...prev,
                onSave: fn
            }));
        }
    }));

    useEffect(() => {
        if (popup.id) {
            Api.get('vans/find?id=' + popup.id)
                .then(res => {
                    setPopup(prev => ({
                        ...prev,
                        data: res.data
                    }))
                });
        }
    }, [popup.update]);

    useEffect(() => {
        Api.get('partners/employees/technicians')
            .then(res => {
                setPopup(prev => ({
                    ...prev,
                    employees: res.data
                }))
            })
    }, []);

    const handleShow = id => {
        setPopup(prev => ({
            ...prev,
            overlay: true,
            id: id,
            data: null,
            update: new Date().getTime()
        }));

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
                modal: true
            }));
        }, 50);

        setValidations(null);
    }

    const handleHide = e => {
        e.preventDefault();

        setPopup(prev => ({
            ...prev,
            modal: false,
            loading: false,
        }));

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: false,
                modal: false
            }));
        }, 50);
    }

    const handleSave = e => {
        e.preventDefault();

        setPopup(prev => ({
            ...prev,
            loading: true,
        }));

        setValidations(null);

        let url = 'vans/' + (popup.id ? 'edit' : 'add');

        let data = new FormData(e.target);

        // при редакция - добавяме ID
        if (popup.id) {
            data.append('id', popup.id);
        }

        Api.post(url, data)
            .then(res => {

                handleHide(e);

                if (typeof popup.onSave === 'function') {
                    popup.onSave();
                }

                document.getElementById("form").reset();

                setPopup(prev => ({
                    ...prev,
                    data: null
                }));

            }).catch(error => {

                setPopup(prev => ({
                    ...prev,
                    loading: false,
                }));

                let _err = error.response;

                if (_err && _err.status && _err.status == 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {

                        setValidations(prevState => {
                            return { ...prevState, [input]: true }
                        });
                    }
                }

            });
    }

    const handleInputChange = e => {
        let name = e.target.name;
        let val = e.target.value;

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }));
    }

    return (
        <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
            <form id="form" className={`${popup.modal ? 'show' : ''} popup-primary small`} onSubmit={handleSave}>
                <h2 className="head">
                    <img src={docIcon} alt="document" className="document-icon" />
                    {trans('headings.vans')}
                    <img src={closeIcon} alt="close" className="close-icon" onClick={handleHide} />
                </h2>

                <div className="popup-container x2">
                    <div className="col">
                        <label>
                            {trans('labels.make')}
                        </label>
                        <input
                            id="brand"
                            type="text"
                            name="brand"
                            value={popup.data?.brand || ''}
                            onChange={handleInputChange}
                            className={validations && validations.brand ? 'validate' : ''}
                        />
                    </div>

                    <div className="col">
                        <label>
                            {trans('labels.model')}
                        </label>
                        <input
                            id="model"
                            type="text"
                            name="model"
                            value={popup.data?.model || ''}
                            onChange={handleInputChange}
                            className={validations && validations.model ? 'validate' : ''}
                        />
                    </div>
                </div>

                <br />

                <div className="popup-container x2">
                    <div className="col">
                        <label>
                            {trans('labels.regNo')}
                        </label>
                        <input
                            id="reg_no"
                            type="text"
                            name="reg_no"
                            value={popup.data?.reg_no || ''}
                            onChange={handleInputChange}
                            className={validations && validations.reg_no ? 'validate' : ''}
                        />
                    </div>
                    <div className="col">
                        <label>
                            {trans('labels.vanDriver')}
                        </label>
                        <select
                            id="employee_id"
                            type="text"
                            name="employee_id"
                            value={popup.data?.employee_id || ''}
                            onChange={handleInputChange}
                            className={validations && validations.employee_id ? 'validate' : ''}
                        >
                            <option value=""></option>
                            {(popup.employees || []).map(e =>
                                <option
                                    value={e.id}
                                >
                                    {e.name} {e.lastname}
                                </option>
                            )}
                        </select>
                    </div>
                </div>

                <div className="footer align-center">
                    {popup.loading ?
                        <img src={loader} alt="loading" />
                        :
                        <>
                            <button className="button" onClick={handleHide}>
                                {trans('buttons.cancel')}
                            </button>
                            <button className="button button-primary" type="submit">
                                {trans('buttons.save')}
                            </button>
                        </>
                    }
                </div>
            </form>
        </div>
    )
}

export default forwardRef(Van);